<template>
  <div class="home">
    <section id="header-home" class="d-flex">
      <div class="container">
        <div class="row">
            <div class="col mb-3">
                <h2>Conheça o Plano Gold</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10">
                <h3>Com o Plano Gold você paga apenas R$35,00 e tem direito:</h3>
            </div>
            <div class="col-md-2">
              <router-link tag="a" class="btn btn-primary btn-block" :to="{name: 'FormSinSaude'}">Adquirir</router-link >
            </div>
        </div>
        <br>
        <plano-gold></plano-gold>
        <div class="row">
          <div class="col-md-3 offset-md-2">
            <h5 class="text-right mt-5">Auxílio Funeral Familiar</h5>
            <p class="text-right">Limitado a pessoas com até 70 anos
de idade .Quando contratada, a Assistência Funeral oferece assistência e prestação de
serviços funerários até R$3.000,00 (três mil reais) em caso de falecimento do segurado
principal,para cônjuge e filhos, garantindo tranquilidade para a sua família.</p>
          </div>
          <div class="col-md-6">
            <img src="@/img/family.jpg" alt="" class="img-fluid rounded">
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-6">
            <img src="@/img/accident.jpg" alt="" class="img-fluid rounded">
          </div>
          <div class="col-md-3">
            <h5 class="mt-5">Seguros de acidentes pessoais</h5>
            <p>Em caso de acidente pessoal e/ou invalidez total/parcial o titular tem direito a uma indenização de até R$5.000,00 (cinco mil reais)</p>
          </div>
        </div>
        <br>  
        <div class="row">
          <div class="col-md-3 offset-md-2">
            <h5 class="text-right mt-5">Cesta básica em caso de
falecimento </h5>
            <p class="text-right">Cesta básica em caso de falecimento do titular/segurado para
seus dependentes (cônjuge e filhos) por 1 ano no valor
R$200,00(duzentos reais mensais)</p>
          </div>
          <div class="col-md-6">
            <img src="@/img/market.jpg" alt="" class="img-fluid rounded">
          </div>
        </div>
        <br>
      </div>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-md-4 offset-md-4 text-center">
          <p>Gostou? Compre agora!</p>
          <router-link tag="a" class="btn btn-primary btn-lg btn-block" :to="{name: 'FormSinSaude'}">Comprar</router-link >
        </div>
      </div>
      <br>
      <achei-descontos-brands></achei-descontos-brands>
    </div>
  </div>
</template>

<script>
import AcheiDescontosBrands from '@/components/shared/AcheiDescontosBrands'
import PlanoGold from '@/components/shared/PlanoGold'
export default {
  components: {
    AcheiDescontosBrands,
    PlanoGold
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/SaibaMaisPlano.vue